import React, { useEffect, useState } from 'react';
import { CloseIcon } from './Icons.jsx';
import './RemovePlayerButton.css';

/**
 * Sends one learner out of the room so they can come back under another name.
 * Two presses, because the roster sits where a stray click lands: the first
 * arms the button, the second removes, and it disarms itself after 3 seconds.
 */
export default function RemovePlayerButton({ player, onRemove, className = '' }) {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (!armed) return undefined;
    const timer = setTimeout(() => setArmed(false), 3000);
    return () => clearTimeout(timer);
  }, [armed]);

  const press = (e) => {
    e.stopPropagation();
    if (!armed) {
      setArmed(true);
      return;
    }
    setArmed(false);
    onRemove(player.id);
  };

  return (
    <button
      type="button"
      className={`remove-player-btn ${armed ? 'is-armed' : ''} ${className}`}
      onClick={press}
      onBlur={() => setArmed(false)}
      aria-label={armed ? `ยืนยันเอา ${player.nickname} ออกจากห้อง` : `เอา ${player.nickname} ออกจากห้อง`}
      title="เอาออกจากห้อง เพื่อให้ตั้งชื่อใหม่"
    >
      {armed ? <span>เอาออก?</span> : <CloseIcon size={14} />}
    </button>
  );
}
